module.exports = __webpack_public_path__ + "static/media/iearn.88f2e966.svg";